const DEFAULT_ROOT_DOMAIN = 'ineedleadcrm.com';

function stripProtocol(value = '') {
  return String(value || '').replace(/^https?:\/\//, '').replace(/\/.*$/, '').trim();
}

function currentProtocol() {
  return window.location.protocol === 'http:' ? 'http' : 'https';
}

export function publicSiteHost() {
  return stripProtocol(import.meta.env.VITE_PUBLIC_SITE_HOST || DEFAULT_ROOT_DOMAIN);
}

export function appHost() {
  return stripProtocol(import.meta.env.VITE_APP_HOST || `app.${publicSiteHost()}`);
}

export function isLocalHost() {
  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
}

export function isPublicSiteHost() {
  return !isLocalHost() && window.location.hostname === publicSiteHost();
}

export function isAppHost() {
  return !isLocalHost() && window.location.hostname === appHost();
}

export function appUrl(path = '/') {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${currentProtocol()}://${appHost()}${cleanPath}`;
}

export function publicSiteUrl(path = '/') {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${currentProtocol()}://${publicSiteHost()}${cleanPath}`;
}
